import React from "react";
import { MdChat, MdExpandMore } from "react-icons/md";
import { FloatingButtonContainer } from "./styles";

const FloatingButton = ({ isOpen, onClick }) => {
	return (
		<FloatingButtonContainer
			onClick={onClick}
			aria-label={isOpen ? "Fechar chat" : "Abrir chat do JOTA"}
		>
			{isOpen ? <MdExpandMore /> : <MdChat />}
		</FloatingButtonContainer>
	);
};

export default FloatingButton;
